import { useState } from "react";
import { get } from '../api'
import { isAdminAccess } from '../../config'

const dummyResponseForQa = [
  {
    "entity_id": "a5b938762a475ff05528aa7bd40c003dbb6df30f",
    "entity_type": "show",
    "title": "Night Road",
    "paid": "NULL",
    "plays": "9053",
    "image_url": "https://djhonz7dexnot.cloudfront.net/47cccc8779b96f129d1ded014c66f45125a53a8b.jpg",
    "duration": "983",
    "topics": "None",
    "creator_name": "Dishant Kedia",
    "days_since_upload": "1 years ago",
    "popularity_score": 5.765191102784844,
    "score": 139.88664
  },
  {
    "entity_id": "6604a329fe4a0c7139502075b7344e25d428549a",
    "entity_type": "show",
    "title": "Secret Affair | सीक्रेट अफेयर   ",
    "paid": "NULL",
    "plays": "26720942",
    "image_url": "http://djhonz7dexnot.cloudfront.net/b7eed3c2b4cd6f44a79744f886d1b96175bb8f4f.webp",
    "duration": "641",
    "topics": "None",
    "creator_name": "Rj Priyal",
    "days_since_upload": "6 months ago",
    "popularity_score": 12.255514977944038,
    "score": 423.6942
  }
]

function useSearchInput({api, paramKey='query', transform = response => response.result}) {
  const [results, setResults] = useState([]);
  const fetchResults = text => {
    get(api, {
      params: {
        [paramKey]: text,
        is_novel: 1,
      }
    }).then((res) => {
      setResults(transform(res))
    })
  }

  // const fetchResults = text => {
  //   get(api, {
  //     params: {
  //       [paramKey]: text
  //     }
  //   }).then((res) => {
  //     setResults(transform(res))
  //   })
  // }

  const handleChange = text => {
    if (!isAdminAccess) return
    if (!text) {
      setResults([])
      return
    }
    fetchResults(text)
  }

  return {
    results,
    onChange: handleChange,
  }
}

export default useSearchInput;
